
// Getter Object for Product_groupsCatalog. Use it by calling mapGetters from the Vuex Host Components.

export const product_groupsCatalogGetters = {
  product_groupsCatalogData: (state) => state.product_groupsCatalogData,
  product_groupsList: (state) => state.product_groupsList,
  product_groupDetails: (state) => state.product_groupDetails,
}


